import { render, staticRenderFns } from "./ProductsNav.vue?vue&type=template&id=04480dbc&"
import script from "./ProductsNav.vue?vue&type=script&lang=js&"
export * from "./ProductsNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports